import PropTypes from "prop-types"
import { map } from "lodash"
import { METRIC_TYPES, METRICS } from "./constants"

export const METRIC_TYPES_SHAPE = PropTypes.oneOf(map(METRIC_TYPES))

export const METRICS_SHAPE = PropTypes.oneOf(map(METRICS))

export const METRIC_OPTION_SHAPE = PropTypes.shape({
  id: METRIC_TYPES_SHAPE.isRequired,
  label: PropTypes.string.isRequired,
  isDefault: PropTypes.bool,
})

export const SUPPORTED_METRICS_SHAPE = PropTypes.objectOf(
  PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(METRIC_OPTION_SHAPE).isRequired,
  }),
)
